import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from 'app/models/User';
import { DataTableHeader } from '../DataTableHeader';

@Component({
  selector: 'app-data-table-row',
  templateUrl: './data-table-row.component.html',
  styleUrls: ['./data-table-row.component.scss'],
  host: {
    class: 'row row-body'
  }
})
export class DataTableRowComponent implements OnInit {
  @Input() id: string;
  @Input() index: number;
  @Input() showAll: boolean;
  @Input() headers: Array<DataTableHeader>;
  @Input() subHeaders: Array<DataTableHeader>;
  @Input() item: any;
  @Input() maxValueMapping: any;
  @Output() goTo: EventEmitter<any> = new EventEmitter<any>();

  get isFreemium() {
    return this._user.isFreemium();
  }

  get isAnonymous() {
    return this._user.isAnonymous();
  }

  constructor(private _user: User) {}

  ngOnInit() {}

  goToClick(headerKey: string, itemValue: any) {
    this.goTo.emit({ key: headerKey, value: itemValue });
  }
}
